import { AxiosRequestConfig } from "axios";

import { ITECommentInput, ITECommentUpdateInput, ITECommentOutput } from "components/ITE/types/comentarios";

import { apiClient, CustomAxiosRequest } from ".";

type getComentariosPropsType = {
	iteId: string;
};

export const getComentarios: CustomAxiosRequest<getComentariosPropsType, ITECommentOutput[]> = (props) => {
	const url = `ite/ite/comentarios`;
	const config: AxiosRequestConfig = {
		method: "GET",
		url,
		headers: {
			"Content-Type": "application/json",
		},
		params: props,
	};
	return apiClient(config);
};

export const postComentario: CustomAxiosRequest<ITECommentInput, ITECommentOutput> = (data) => {
	const url = `ite/ite/comentarios`;
	const config: AxiosRequestConfig = {
		method: "POST",
		url,
		headers: {
			"Content-Type": "application/json",
		},
		data: data,
	};
	return apiClient(config);
};

type putComentarioPropsType = {
	id: string;
	data: ITECommentUpdateInput;
};

export const putComentario: CustomAxiosRequest<putComentarioPropsType, ITECommentOutput> = (data) => {
	const url = `ite/ite/comentarios/${data.id}`;
	const config: AxiosRequestConfig = {
		method: "PUT",
		url,
		headers: {
			"Content-Type": "application/json",
		},
		data: data.data,
	};
	return apiClient(config);
};
